import React from 'react';
import classNames from 'classnames';
import styles from './orderModule.scss';
import BrickList from './brickList/brickList';
import ArticleNumber from './articleNumber/articleNumber';
import ArticlePrice from './articlePrice/articlePrice';
import DeliveryTime from './deliveryTime/deliveryTime';
import BasketPanel from './basketPanel/basketPanel';
import { IInjectedProps } from '../../types';
import { inject, observer } from 'mobx-react';
import { SalesFlag } from './salesFlag/salesFlag';
import TabNavigationHelper from '../../helpers/tabNavigationHelper';
import FragmentPlaceholder from '../fragmentPlaceholder/fragmentPlaceholder';
import LinkGenerator from './linkGenerator/linkGenerator';

const OrderModule = inject('store')(
    observer(({ store }: IInjectedProps) => {
        if (!store) return null;
        const tabNavigation: TabNavigationHelper = TabNavigationHelper.instance;

        return (
            <div className={styles.order_module_container} ref={(el) => tabNavigation.setGroupAtt(el)}>
                {
                    !store.dataStore.contextData.isEsApp &&
                    <div className={classNames(styles.om_breadcrumb_fragment_container)}>
                        {
                            // eslint-disable-next-line max-len
                            <FragmentPlaceholder src={`/ESPP.Breadcrumb/breadcrumb?pageType=Detail&seoSlug=${store?.dataStore.category.seoSlug}&containerId=fsp_main_breadCrumb`}
                                ignoreErrors={true}
                                timeout={2}
                            />
                        }
                    </div>
                }
                <div className={styles.first_item}>
                    <ArticleNumber />
                </div>
                { !store.dataStore.contextData.isRelease && <LinkGenerator/> }
                <SalesFlag />
                <ArticlePrice />
                <div className={styles.order_module_availability_container}>
                    <DeliveryTime />
                </div>
                <BrickList />
                <BasketPanel />
            </div>
        );
    })
);

export default OrderModule;
